import { combineReducers } from 'redux';
import topicCreatePage from './topic-create-page';
import topicEditPage from './topic-edit-page';
import shareDialog from './share-dialog';
import allTopics from './all-topics';
import featuredTopics from './featured-topics';
import questions from './questions';
import deleteConfirmation from './delete-confirmation-dialog';
import questionViewPage from './question-view-page';
import questionListPage from './question-list-page';
import questionAskPage from './question-ask-page';
import questionEditPage from './question-edit-page';
import globalWatch from './global-watch';
import adminPage from './admin-page';
import acceptAnswerRequest from './accept-answer-request';
import expertsByAllTime from './experts-by-all-time';
import expertsByTopic from './experts-by-topic';
import expertsByWeek from './experts-by-week';
import filteredSpaces from './filtered-spaces';
import relatedQuestions from './related-questions';
import users from './users';
import votingRequest from './voting-request';
import answers from './answers';

export default combineReducers({
	featuredTopics,
	allTopics,
	questions,
	answers,
	filteredSpaces,
	relatedQuestions,
	users,
	expertsByAllTime,
	expertsByTopic,
	expertsByWeek,
	acceptAnswerRequest,
	votingRequest,
	deleteConfirmation,
	topicCreatePage,
	topicEditPage,
	questionViewPage,
	questionListPage,
	questionAskPage,
	questionEditPage,
	shareDialog,
	globalWatch,
	adminPage,
});
